import { render, staticRenderFns } from "./CoinPurchasePendingCoinPurchaseBonus.vue?vue&type=template&id=8fc24532&scoped=true"
import script from "./CoinPurchasePendingCoinPurchaseBonus.vue?vue&type=script&lang=ts"
export * from "./CoinPurchasePendingCoinPurchaseBonus.vue?vue&type=script&lang=ts"
import style0 from "./CoinPurchasePendingCoinPurchaseBonus.vue?vue&type=style&index=0&id=8fc24532&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc24532",
  null
  
)

export default component.exports